import { getStorageBasedFeature } from 'reactApp/appHelpers/featuresHelpers/utils';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

/** CLOUDWEB-18070 Отображать ли новый хедер вьювера */
export const hasViewerMenu = (storage?: EStorageType) =>
    !getStorageBasedFeature('viewer-menu-disabled-storages', storage) && getStorageBasedFeature('viewer-menu-storages', storage);
